export default "__VITE_ASSET__C63V9uOM__"